module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.show_login) ? _c('div', {
    staticClass: "main-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [_c('div', {
    staticClass: "header-wrap-sticky",
    attrs: {
      "id": "pageNotStickyHeader"
    }
  }, [_c('component-header')], 1), _vm._v(" "), _c('div', {
    staticClass: "pager pager-clear-sticky"
  }, [_c('div', {
    staticClass: "container",
    attrs: {
      "id": "topPanel"
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "loading-md"
  })]) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "card-box-0"
  }, _vm._l((_vm.notifications), function(noti, index) {
    return _c('div', {
      staticClass: "card card-02",
      staticStyle: {
        "border-bottom": "#eeeded solid",
        "padding": "8px 0"
      }
    }, [_c('a', {
      staticClass: "card-link",
      staticStyle: {
        "text-decoration": "none",
        "color": "inherit"
      },
      on: {
        "click": function($event) {
          _vm.clickNotifications(noti.notification_ref, noti.notification_url)
        }
      }
    }, [_c('div', {
      staticStyle: {
        "float": "left",
        "width": "80%"
      }
    }, [_c('div', {
      staticClass: "card-arm-line"
    }, [(noti.notification_click == 0) ? _c('span', [(noti.notification_header && (noti.notification_header != '')) ? _c('h6', [_vm._v(_vm._s(noti.notification_header))]) : _vm._e(), _vm._v(" "), _c('p', {
      staticStyle: {
        "font-weight": "bolder"
      }
    }, [_vm._v(_vm._s(noti.notification_message))]), _vm._v(" "), (noti.notification_cta && (noti.notification_cta != 0)) ? _c('span', {
      staticStyle: {
        "float": "left",
        "font-size": "12px",
        "color": "#ff0066"
      }
    }, [_vm._v(_vm._s(noti.notification_cta_name))]) : _vm._e(), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right",
        "font-size": "12px",
        "color": "#ff0066"
      }
    }, [_vm._v(_vm._s(noti.notification_time_ago))])]) : _c('span', [(noti.notification_header && (noti.notification_header != '')) ? _c('h6', [_vm._v(_vm._s(noti.notification_header))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(noti.notification_message))]), _vm._v(" "), (noti.notification_cta && (noti.notification_cta != 0)) ? _c('span', {
      staticStyle: {
        "float": "left",
        "font-size": "12px",
        "color": "#ff0066"
      }
    }, [_vm._v(_vm._s(noti.notification_cta_name))]) : _vm._e(), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right",
        "font-size": "12px",
        "color": "#ff0066"
      }
    }, [_vm._v(_vm._s(noti.notification_time_ago))])]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right",
        "width": "20%"
      }
    }, [_c('div', {
      staticClass: "card-avatar-circle"
    }, [_c('img', {
      attrs: {
        "src": noti.notification_image
      }
    })])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])])
  }))])])]), _vm._v(" "), _c('component-footer', {
    key: _vm.componentMenuBottomkey
  })], 1) : _c('div', [_c('component-landing')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ab8f302"}!./src/pages/Notifications/template.html
// module id = 383
// module chunks = 0